var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_156",
    "data-name": "Grupo 156",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.909,
    height: 14.905,
    viewBox: "0 0 20.909 14.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M4644.454,1107.045h-14.639a3.139,3.139,0,0,1-3.136-3.135v-8.635a3.139,3.139,0,0,1,3.136-3.135h14.639a3.138,3.138,0,0,1,3.134,3.135v8.635A3.138,3.138,0,0,1,4644.454,1107.045Zm-14.639-13.125a1.357,1.357,0,0,0-1.356,1.355v8.635a1.357,1.357,0,0,0,1.356,1.355h14.639a1.356,1.356,0,0,0,1.354-1.355v-8.635a1.356,1.356,0,0,0-1.354-1.355Z",
    transform: "translate(-4626.68 -1092.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149",
    transform: "translate(12.392 6.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M4875.572,1227.488a.889.889,0,0,1-.646-.277l-4.252-4.483a.89.89,0,1,1,1.291-1.225l4.252,4.483a.889.889,0,0,1-.645,1.5Z",
    transform: "translate(-4870.429 -1221.226)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    transform: "translate(2.595 2.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M4685.573,1142.436l-7.569-6.9a.89.89,0,0,1,1.2-1.315l6.372,5.809,6.388-5.81a.89.89,0,1,1,1.2,1.316Z",
    transform: "translate(-4677.714 -1133.988)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151",
    transform: "translate(2.513 6.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M4676.994,1227.488a.89.89,0,0,1-.646-1.5l4.252-4.483a.89.89,0,1,1,1.291,1.224l-4.253,4.483A.886.886,0,0,1,4676.994,1227.488Z",
    transform: "translate(-4676.104 -1221.226)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFooter);
export default __webpack_public_path__ + "static/media/mail-footer.b4dc12668e7ac40be1815acdb51de2a4.svg";
export { ForwardRef as ReactComponent };